export function enhanceEpiForms() {
    // grabs only nested text nodes
    function textNodesUnder(el) {
        var n, a = [], walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
        while (n = walk.nextNode()) a.push(n);
        return a;
    }

    let containers = Array.prototype.slice.call(document.querySelectorAll('.EPiServerForms'));

    containers.forEach(container => {
        let newWrapper = document.createElement('div');
        newWrapper.className = 'epi-form';
        container.parentNode.insertBefore(newWrapper, container);
        newWrapper.appendChild(container);

        let formChoiceLabels = Array.prototype.slice.call(container.querySelectorAll('.FormChoice:not(.FormChoice--Image) > label'));
        let formID = container.id || (Math.ceil(Math.random() * 1000));

        formChoiceLabels.forEach((fieldLabel, index) => {
            let fieldInput = fieldLabel.querySelector('input');
            let fieldName = `input-${formID}-${index}`;
            fieldLabel.parentNode.insertBefore(fieldInput, fieldLabel);
            fieldLabel.setAttribute('for', fieldName);
            fieldInput.id = fieldName;
        });
    });

    let formChoiceImageLabels = Array.prototype.slice.call(document.querySelectorAll('.EPiServerForms .FormChoice--Image > label'));

    formChoiceImageLabels.forEach(fieldLabel => {
        fieldLabel.classList.add('enhanced-fields');
    });

    let requiredFields = Array.prototype.slice.call(document.querySelectorAll('.EPiServerForms div.Form__Element:not(.ValidationRequired):not(.FormCaptcha)'))
    requiredFields.forEach(field => {
        let fieldLabel = field.querySelectorAll('.Form__Element__Caption')[0];

        if (fieldLabel) {
            let optionalTag = document.createElement('span');
            let optionalText = document.createTextNode('(Optional)');
            

            optionalTag.className = 'not-required';
            optionalTag.appendChild(optionalText);
            fieldLabel.appendChild(optionalTag);
        }
    });
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/epi-forms.ts